(ns client-portal.client.core.views
  (:require [cljs-time.coerce :as t.coerce]
            [cljs-time.format :as t.f]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [client-portal.client.core.data :as core.d]))

(def date-formatter-MM-DD-YY (t.f/formatter "MM/DD/YY"))

(defn timeframe-label [tf [start end]]
  (let [format-date #(t.f/unparse date-formatter-MM-DD-YY (t.coerce/from-date %))]
    (case (str tf)
      "most-recent" "Most Recent"
      "0" "Today"
      "-2" "Live"
      "1" "Yesterday"
      "7" "Last 7 days"
      "30" "Last 30 days"
      "90" "Last 90 days"
      "-1" (if (and start end)
             (str (format-date start) " - " (format-date end))
             "Custom Range")
      nil)))

(defn timeframe-dropdown [_]
  (let [custom-date-range-picker-open?* (re/ratom false)
        sel-timeframe- (re/subscribe [:core/selected-timeframe-])
        sel-timeframe-date-range- (re/subscribe [:core/selected-timeframe-date-range-])
        admin?- (re/subscribe [:account/admin-role?-])]
    (fn [{:keys [selected-timeframe on-change style show-live? show-most-recent?]}]
      (let [selected-timeframe (or selected-timeframe @sel-timeframe-)
            on-change (or on-change
                          (fn [{:keys [tf start end]}]
                            (re/dispatch [:router/go-with-merged-query-params
                                          {:tf tf :start start :end end}])
                            (re/dispatch [:core/select-timeframe tf])
                            (re/dispatch [:core/select-timeframe-date-range
                                          (core.d/start-end-strings->date-range start end)])))
            custom-range-text (if (and (= selected-timeframe -1)
                                       (not @custom-date-range-picker-open?*))
                                (timeframe-label -1 @sel-timeframe-date-range-)
                                "Custom Range")
            ->option (fn [v] {:text (timeframe-label v nil) :value v})
            options (->> [(when (and @admin?- show-most-recent?)
                            (->option core.d/most-recent-timeframe-value))
                          (->option "0")
                          (when (or show-live? (= selected-timeframe -2))
                            (->option "-2"))
                          (->option "1")
                          (->option "7")
                          (->option "30")
                          (->option "90")
                          {:text custom-range-text :value "-1"}]
                         (filterv some?))]
        [:div {:style (merge {:flex "0 0 175px"
                              :position :relative}
                             style)}
         [alc/up-dropdown
          {:options options
           :placeholder "Select an option"
           :value (if @custom-date-range-picker-open?*
                    "-1"
                    (str selected-timeframe))
           :on-change (fn [v]
                        (if (= v "-1")
                          (reset! custom-date-range-picker-open?* true)
                          (on-change {:tf (if (= v core.d/most-recent-timeframe-value)
                                            v
                                            (util/parse-int v))})))}]
         (when @custom-date-range-picker-open?*
           [:div {:style {:position :absolute
                          :top 40
                          :right 0
                          :z-index 7}}
            [alc/date-range-picker
             {:form-path core.d/manage-path
              :form-name :timeframe-date-range
              :max-date (js/Date.)
              :on-apply (fn [[start end]]
                          (reset! custom-date-range-picker-open?* false)
                          (on-change {:tf -1
                                      :start (core.d/format-start-end-date start)
                                      :end (core.d/format-start-end-date end)})
                          (re/dispatch [:core/timeframe-date-range-changed]))
              :on-cancel (fn []
                           (reset! custom-date-range-picker-open?* false))}]])]))))

(defn crew-type-radio [_]
  (let [ai-user?- (re/subscribe [:account/has-every-role?- [:ai-user]])
        sel-crew-type- (re/subscribe [:core/selected-crew-type-])]
    (fn [{:keys [selected-crew-type on-change]}]
      (when @ai-user?-
        [alc/up-toggle-group {:type "single"
                              :value (or selected-crew-type @sel-crew-type- "human")
                              :on-value-change (fn [v]
                                                 (when (seq v)
                                                   (if on-change
                                                     (on-change v)
                                                     (do
                                                       (re/dispatch [:router/go-with-merged-query-params
                                                                     {:ct v}])
                                                       (re/dispatch [:core/select-crew-type v])))))
                              :items [{:value "human" :content "Human Agent"}
                                      {:value "ai" :content "AI Agent"}]
                              :style {"--spacing" "0.225rem"}}]))))

(defn agent-dropdown [_]
  (let [agents- (re/subscribe [:core/ai-agent-list-])
        cur-qps- (re/subscribe [:router/current-query-params-])
        cur-route- (re/subscribe [:router/current-route-])
        session-id- (re/subscribe [:core/ai-agent-session-id-])]
    (fn [{:keys [style]}]
      (let [agents (util/when-not-loading @agents-)
            ;; Agents can only be picked at the start of a new chat, not mid-session.
            in-session? (or (not-empty @session-id-)
                            (= (first @cur-route-) :ai-agent/session))
            selected (:agent-id (util/->kebab-case-keywords @cur-qps-))
            options (mapv (fn [{:keys [public-id label]}]
                            {:text label :value public-id})
                          agents)]
        (when (not-empty options)
          [:div {:style (merge {:flex "0 0 200px"}
                               style)}
           [alc/up-dropdown
            {:options options
             :placeholder "Select an agent"
             :disabled (boolean in-session?)
             :value (or selected "")
             :on-change (fn [v]
                          (re/dispatch [:router/go-with-merged-query-params
                                        {:agentId v}]))}]])))))